import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '../../../BaseComponents/Image'

type KickoffAreaImageProps = {
    height: number
    width: number
    imageUrl?: string
}

const OPAQUE_IMAGE_SIZE = 48
const KICK_OFF_AREA = 80

const KickoffArea: FC<KickoffAreaImageProps> = ({ height, width, imageUrl }) => (
    <Grid
        position="absolute"
        top={(height - KICK_OFF_AREA) / 2}
        left={(width - KICK_OFF_AREA) / 2}
        center
        height={KICK_OFF_AREA}
        width={KICK_OFF_AREA}
        borderRadius={KICK_OFF_AREA / 2}
        borderColor="WHITE"
        border={2}
    >
        {imageUrl ? (
            <Grid noExpand opacity={0.4} width={OPAQUE_IMAGE_SIZE}>
                <Image size="L" aspectRatio="1:1" imageUrl={imageUrl} width={OPAQUE_IMAGE_SIZE} />
            </Grid>
        ) : null}
    </Grid>
)

export default KickoffArea
